/*----------------------------------------------------------*/
/* OCULTAR COLORES DE THUMBNAILS */
/*window.show_hide_thumb_custom = (item) => {
  let swatch_color_selected = item.parentNode.getAttribute('data-value');
  let thumb_visible = false;

  thumbnails_array.forEach(thumb_item => {
    let thumb_item_parent = thumb_item.parentNode;
    let data_color = thumb_item.getAttribute('data-name') || '';  // Asegúrate de que no sea null
    
    if (data_color.includes(swatch_color_selected)) {
      if (thumb_item_parent.classList.contains('hide')) {
        thumb_item_parent.classList.remove('hide');
      }
      thumb_visible = true;
    } else {
      thumb_item_parent.classList.add('hide');
    }
  });

  // Si no hay thumbs visibles, mostrar todos
  if (!thumb_visible) {
    thumbnails_array.forEach(thumb_item => {
      thumb_item.parentNode.classList.remove('hide');
    });
  }
}*/
/*
const swatch_color_array = document.querySelectorAll('.color-swatch');
const thumbnails_array = document.querySelectorAll('.product__thumb');
const variant_checked = document.querySelector('[data-option-name="color"] .variant-input input[checked="checked"]');

if (Boolean(variant_checked)) {
  window.show_hide_thumb_custom(variant_checked.parentNode.querySelector('.variant__button-label'));
}

if (Boolean(swatch_color_array)) {
  swatch_color_array.forEach(item=>{
    item.addEventListener("click", function(event){
      window.show_hide_thumb_custom(item);
    });    
  });
}
*/
/*----------------------------------------------------------*/

function selectedColor(){
  let item = document.querySelectorAll('#CollectionSidebar-2-filter-color .tag');
  item.forEach(elem =>{
    if(elem.classList.contains('tag--active')){
      element2 = elem.querySelector('.tag__text');
      console.log(element2.innerHTML);
    }
  });
}
selectedColor();